<app-header [title]="title"></app-header>
<!-- bootstrap version changes -->
<div class="col-md-12 col-sm-12 grid-h">
  <div class="col-md-12 p-0 mt-10">
    <div class="board">
      <!-- bootstrap removed nav-tabs HTML -->
      <ul class="steps steps-5">
        <li (click)="navigation('client')"
          [ngClass]="[ShowTabName == 'client' ? 'active' : ClientComplete ? 'completed' : '']">
          <div class="li-title">
            Client Configuration
          </div>
        </li>
        <li (click)="navigation('saag')"
          [ngClass]="[ShowTabName == 'saag' ? 'active' : clientData.Is_SAAG_Uploaded ? 'completed' : '']">
          <div class="li-title">
            SAAG Master
          </div>
        </li>
        <li (click)="navigation('insurance')"
          [ngClass]="[ShowTabName == 'insurance' ? 'active' : clientData.Is_Insurance_Uploaded ? 'completed' : '']">
          <div class="li-title">
            client Insurance
          </div>
        </li>
        <li (click)="navigation('provider')"
          [ngClass]="[ShowTabName == 'provider' ? 'active' : clientData.Is_Provider_Uploaded ? 'completed' : '']">
          <div class="li-title">
            Provider Master
          </div>
        </li>
        <li (click)="navigation('inventory')"
          [ngClass]="[ShowTabName == 'inventory' ? 'active' : clientData.Is_Inventory_Uploaded ? 'completed':'']">
          <div class="li-title">
            Client Inventory
          </div>
        </li>
        <li (click)="navigation('dropdown')"
          [ngClass]="[ShowTabName == 'dropdown' ? 'active' : clientData.Is_Dropdown_Uploaded ? 'completed':'']">
          <div class="li-title">
            Dropdown Management
          </div>
        </li>
        <!-- <li (click)="navigation('formula')"
          [ngClass]="[ShowTabName == 'formula' ? 'active' :'',clientData.Is_Formula_Uploaded ? 'completed':'']">
          <div class="li-title">
            Formula Management
          </div>
        </li> -->
        <li (click)="navigation('pcn')" *ngIf="clientData.Is_PCN==true"
          [ngClass]="[ShowTabName == 'pcn' ? 'active' :'',clientData.Is_PCN_Uploaded ? 'completed':'']">
          <div class="li-title">
            PCN Configuration
          </div>
        </li>
        <!-- <li (click)="navigation('special_project')"
          [ngClass]="[ShowTabName == 'special_project' ? 'active' :'',clientData.Is_Special_Project_Uploaded ? 'completed':'']">
          <div class="li-title">
            Special Project
          </div>
        </li> -->
        <!--  -->
        <!-- <li (click)="navigation('appeal')"
          [ngClass]="[ShowTabName == 'appeal' ? 'active' :'',clientData.Is_Appeal_Uploaded ? 'completed':'']">
          <div class="li-title">
            Appeal Management
          </div>
        </li> -->
      </ul>
    </div>
    <!-- client component  -->

    <!-- <div class="modal fade client-list" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"> -->
    <app-client (next_page)="next_page($event)" [SelectedClientData]="clientData" [selectClient]="TabError"
      (messageEvent)="receiveClient($event)" *ngIf="ShowTabName == 'client'" (managePCN)="managePCN($event)"
      (setCellClickedEvent)="setCellClickedEvent($event)"
      [getCellClickedEvents]="setCellClickedEvents">
    </app-client>
    <!-- </div> -->

    <app-saag (next_page)="next_page($event)" [(ClientData)]="clientData" *ngIf="ShowTabName == 'saag'"></app-saag>
    <app-insurance (next_page)="next_page($event)" [(ClientData)]="clientData" *ngIf="ShowTabName == 'insurance'">
    </app-insurance>
    <app-provider (next_page)="next_page($event)" [(ClientData)]="clientData" *ngIf="ShowTabName == 'provider'">
    </app-provider>
    <app-inventory (next_page)="next_page($event)" [(ClientData)]="clientData" *ngIf="ShowTabName == 'inventory'">
    </app-inventory>
    <app-dropdown (next_page)="next_page($event)" [(ClientData)]="clientData" *ngIf="ShowTabName == 'dropdown'">
    </app-dropdown>
    <app-formula (next_page)="next_page($event)" [(ClientData)]="clientData" *ngIf="ShowTabName == 'formula'">
    </app-formula>
    <app-pcn-configuration (next_page)="next_page($event)" [(ClientData)]="clientData"
      *ngIf="clientData.Is_PCN==true && ShowTabName == 'pcn'">
    </app-pcn-configuration>
    <app-special-project (next_page)="next_page($event)" [(ClientData)]="clientData"
      *ngIf="ShowTabName == 'special_project'"></app-special-project>
    <app-appeal (next_page)="next_page($event)" [(ClientData)]="clientData" *ngIf="ShowTabName=='appeal'"></app-appeal>
    <!-- <app-deactivate-project></app-deactivate-project> -->
  </div>
</div>
